"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ai_tutor_module_scss_1 = __importDefault(require("./ai-tutor.module.scss"));
var chatWorkspace_1 = __importDefault(require("./chatWorkspace"));
// AI Tutor feature that allows students to ask general questions about the curriculum.
var GeneralChatTutor = function () {
    return (react_1.default.createElement("div", { className: ai_tutor_module_scss_1.default.tutorContainer },
        react_1.default.createElement(chatWorkspace_1.default, null)));
};
exports.default = GeneralChatTutor;
